<template>
  <div class="notes">
    <form>
      <b-form-group label="Add new note">
        <textarea v-model.trim="message" class="form-control" id="exampleFormControlTextarea1" rows="3"></textarea>
      </b-form-group>
      <button
        @click="addNote"
        :class="{ disabled: !message }"
        class="btn btn-primary pull-right"
        >Add note</button>
    </form>

    <div class="card" v-for="note in notes" :key="note.id">
      <div class="card-body">
        <h6 class="card-subtitle mb-2 text-muted"><small>By <strong>{{note.createdByUserFullName || 'unknown'}}</strong> on <strong>{{note.dateCreated | date}}</strong></small></h6>
        <p class="card-text">{{note.note}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { date } from '@/shared/filters';

export default {
  name: 'Notes',
  props: [
    'service',
    'parentId'
  ],
  data() {
    return {
      notes: [],
      message: '',
    }
  },
  filters: {
    date
  },
  methods: {
    async reloadNotes() {
      this.notes = (await this.service.getAll(this.parentId) || []).reverse();
    },
    async addNote(e) {
      (e || event).preventDefault();
      if (this.message) {
        await this.service.createNote(this.parentId, this.message);
        this.message = '';
        this.reloadNotes();
      }
    }
  },
  mounted() {
    this.reloadNotes();
  }
}
</script>

<style lang="scss">
.notes {
  max-width: 550px;
  margin: 1rem auto;
  form {
    margin-bottom: 3rem;
    &::after {
      content: '';
      display: block;
      clear: both;
    }
  }
  .card-text {
    white-space: pre-wrap;
  }
}
</style>
